import type { IconSvgObject } from './types';

const RotateCropIcon: IconSvgObject = [
  ["path", { d: "M2 15C2 19 5 22 9 22V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 9C22 5 19 2 15 2V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 4.5V15C7 16.1046 7.89543 17 9 17H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17 19.5V9C17 7.89543 16.1046 7 15 7H4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default RotateCropIcon;
